import type { AnswerValue, AnswerMap, FormSchemaDef } from '../types';

/**
 * スキーマの質問定義と現在の回答から、そのステップが有効かどうかを判定する
 */
export function isStepValid(
  schema: FormSchemaDef,
  stepIndex: number,
  answers: Record<string, AnswerValue>,
): boolean {
  const step = schema.steps[stepIndex];
  if (!step) return false;

  return step.questions.every((question) => {
    if (!question.required) return true;

    const answer = answers[question.id];
    if (!answer) return false;

    switch (question.type) {
      case 'SINGLE_SELECT': {
        const a = answer as AnswerMap['SINGLE_SELECT'];
        return a.selectedId !== '';
      }
      case 'MULTI_SELECT': {
        const a = answer as AnswerMap['MULTI_SELECT'];
        return a.selectedIds.length > 0;
      }
      case 'CONDITIONAL_SELECT': {
        const a = answer as AnswerMap['CONDITIONAL_SELECT'];
        // 全アイテムにプライマリ選択が必要
        const allAnswered = question.items.every(
          (item) => a.selections[item.id] != null,
        );
        if (!allAnswered) return false;
        // 条件付きルールに該当するアイテムにはセカンダリ選択が必要
        const conditionalValid = question.items.every((item) => {
          const primaryValue = a.selections[item.id];
          const matchingRule = question.conditionalRules.find(
            (rule) => rule.triggerValue === primaryValue,
          );
          if (!matchingRule) return true;
          return a.secondarySelections[item.id]?.[matchingRule.triggerValue] != null;
        });
        return conditionalValid;
      }
      default:
        return false;
    }
  });
}
